import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'
import { useActiveDisciplineInfoApi } from '@api/disciplines/active-discipline-info.hook'

export const useMiddlewareDisciplineInfo = (): void => {
  onDisciplineReady(() => {
    void useActiveDisciplineInfoApi()
  }, { hook: 'NONE' })
}
